const resourceTooltips = {
  dataset: {
    created: "Dataset has just been created and will be setup shortly",
    pending:
      "Dataset is being setup and your databases will be created. This can take a long time depending on your data.",
    ready: "The dataset is setup and ready to be used",
    removing: "The dataset is being removed alongside all of its databases",
    removed: "The dataset and its databases have been removed",
    errored: "There was an unexpected error on the dataset or one of its databases. Contact support",
  },
  database: {
    created: "The database has just been created and will be setup shortly",
    available: "The database is ready and available to be checked out",
    pending: "The database is being setup",
    claimed: "The database has been claimed and will be in use shortly",
    in_use: "The database is being used by a user",
    removing: "The database is being removed",
    removed: "The database has been removed",
    errored: "There was an unexpected error on the database. Contact support",
  },
} as Record<string, Record<string, string>>;

export default resourceTooltips;
